import React from 'react';
import { getSessionLockboxId, saveLockboxId } from '#modules/utils/jwt';

export const EntityContext = React.createContext({});

export const EntityProvider = ({ children }) => {
  const storedLockboxId = getSessionLockboxId();
  const [activeEntityId, setActiveEntityId] = React.useState(null);
  const [activeLockboxId, setActiveLockboxId] = React.useState(storedLockboxId);
  const [activeProfiles, setActiveProfiles] = React.useState(null);
  const [entityInfo, setEntityInfo] = React.useState({});
  const [transactionsLoading, setTransactionsLoading] = React.useState(false);
  const [transactionsData, setTransactionsData] = React.useState(null);
  const [ordersLoading, setOrdersLoading] = React.useState(false);
  const [ordersData, setOrdersData] = React.useState(null);
  const [planOrdersData, setPlanOrdersData] = React.useState(null);
  const [portfolioLoading, setPortfolioLoading] = React.useState(false);
  const [portfolioData, setPortfolioData] = React.useState(null);
  const [walletAddresses, setWalletAddresses] = React.useState({});
  const [lockboxesLoading, setLockboxesLoading] = React.useState(false);
  const [lockboxesList, setLockboxesList] = React.useState(null);
  const [entityDetailsSynced, setEntityDetailsSynced] = React.useState(false);

  const onSetActiveLockboxId = (lockboxId) => {
    setActiveLockboxId(lockboxId);
    saveLockboxId(lockboxId);
  };
  const value = {
    activeLockboxId,
    setActiveLockboxId: onSetActiveLockboxId,
    activeEntityId,
    setActiveEntityId,
    activeProfiles,
    setActiveProfiles,
    entityInfo,
    setEntityInfo,
    transactionsData,
    setTransactionsData,
    transactionsLoading,
    setTransactionsLoading,
    walletAddresses,
    setWalletAddresses,
    lockboxesLoading,
    setLockboxesLoading,
    lockboxesList,
    setLockboxesList,
    ordersLoading,
    setOrdersLoading,
    portfolioLoading,
    setPortfolioLoading,
    portfolioData,
    setPortfolioData,
    ordersData,
    setOrdersData,
    planOrdersData,
    setPlanOrdersData,
    entityDetailsSynced,
    setEntityDetailsSynced,
  };
  return (
    <EntityContext.Provider value={value}>{children}</EntityContext.Provider>
  );
};
